import { memo, useState } from "react";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { inventoryRoutes } from "../../../../router/routesConstants";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { useAppDispatch } from "../../../../redux/hooks";
import { postDeactivateProductWms } from "../../../../redux/api/inventory.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import { setProductsBlockedStatus } from "../../../../redux/reducer/inventory.reducer";
import { SvgIconType } from "../../../../helpers/SvgIcon";
import userRoles from "../../../../constants/userRoles";
import usePermissions from "../../../../router/usePermissions";

function NomenclatureTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const [isLoading, setIsLoading] = useState(false);

  const isBlocked = crudData?.blocat;

  const handleGoToEditProduct = () => {
    return `/${inventoryRoutes.inventory}/${inventoryRoutes.nomenclature}/${inventoryRoutes.editProduct}?idProdus=${itemId}`;
  };

  const handleGoToEditPackage = () => {
    return `/${inventoryRoutes.inventory}/${inventoryRoutes.nomenclature}/${inventoryRoutes.editPackage}?idProdus=${itemId}`;
  };

  const handleGoToEditLimit = () => {
    return `/${inventoryRoutes.inventory}/${inventoryRoutes.nomenclature}/${inventoryRoutes.editLimit}?idProdus=${itemId}`;
  };

  const handleGoToCopyProduct = () => {
    return `/${inventoryRoutes.inventory}/${inventoryRoutes.nomenclature}/${inventoryRoutes.copyProduct}?idProdus=${itemId}`;
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    const resultAction = await dispatch(
      postDeactivateProductWms({
        id: itemId,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postDeactivateProductWms) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postDeactivateProductWms) ===
      endpointStatus.fulfilled
    ) {
      dispatch(setProductsBlockedStatus(itemId));
    }
  };

  const deactivateButtonProperties: {
    tooltipTitle: string;
    modalTitle: string;
    modalSubtitle: string;
    svgType: SvgIconType;
  } = {
    tooltipTitle: `${isBlocked ? "Activare" : "Dezactivare"} produs`,
    modalTitle: isBlocked ? "Activare produs" : "Dezactivare produs",
    modalSubtitle: `Doriti sa ${
      isBlocked ? "activati" : "dezactivati"
    } produsul ${crudData.numeProdusErp}`,
    svgType: isBlocked ? "LOCK_OPEN" : "LOCK_CLOSE",
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData.numeProdusErp}
      ariaLabel={`Actiuni pentru produsul ${crudData.numeProdusErp}`}
      items={[
        {
          id: "edit-product",
          label: "Editare produs",
          icon: "PRODUCT",
          tooltip:
            "Deschide modificarea datelor produsului si a asocierii cu produsul ERP.",
          navigate: handleGoToEditProduct(),
        },
        {
          id: "edit-package",
          label: "Editare ambalaj",
          icon: "PACKAGE",
          tooltip:
            "Deschide modificarea dimensiunilor si greutatilor cutiei si ambalajului.",
          navigate: handleGoToEditPackage(),
        },
        {
          id: "edit-limit",
          label: "Editare limita",
          icon: "LIMITS",
          tooltip:
            "Deschide configurarea procentului, limitei minime si numarului de coloane.",
          navigate: handleGoToEditLimit(),
        },
        {
          id: "copy",
          label: "Copiere produs",
          icon: "COPY",
          tooltip: "Deschide formularul de copiere a acestui produs.",
          hidden: !isAuthorized(userRoles.COPY_PRODUCT_NOMENCLATURE),
          navigate: handleGoToCopyProduct(),
        },
        {
          id: "toggle-status",
          dividerBefore: true,
          label: deactivateButtonProperties.tooltipTitle,
          icon: deactivateButtonProperties.svgType,
          tooltip: isBlocked
            ? "Reactiveaza produsul blocat."
            : "Dezactiveaza produsul dupa confirmare.",
          hidden: !isAuthorized(userRoles.DEACTIVATE_PRODUCT_NOMENCLATURE),
          loading: isLoading,
          color: isBlocked ? "success" : "error",
          withConfirmationModal: {
            modalTitle: deactivateButtonProperties.modalTitle,
            modalSubtitle: deactivateButtonProperties.modalSubtitle,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleSubmit,
          },
        },
      ]}
    />
  );
}

export default memo(NomenclatureTableActionButtons);
